export const PACKAGING_MATERIAL_LABELS = {
    GLASS: 'Sklo',
    PAPER_CARDBOARD: 'Obaly z papiera/lepenky',
    PAPER_COMPOSITE: 'Kompozitné obaly na báze papiera',
    STEEL: 'Oceľ',
    ALUMINUM_RIGID: 'Hliník – pevný',
    ALUMINUM_FLEXIBLE: 'Hliník – stredne pevný a pružný',
    PET_RIGID: 'PET – pevný',
    PET_FLEXIBLE: 'PET – pružný',
    PE_RIGID: 'PE – pevný',
    PE_FLEXIBLE: 'PE – pružný',
    PP_RIGID: 'PP – pevný',
    PP_FLEXIBLE: 'PP – pružný',
    HDPE_PP_RIGID: 'HDPE a PP – pevný',
    PS_XPS_RIGID: 'PS a XPS – pevný',
    EPS_RIGID: 'EPS – pevný',
    OTHER_RIGID_PLASTIC: 'Ostatné pevné plasty',
    OTHER_FLEXIBLE_PLASTIC: 'Ostatné pružné plasty',
    BIODEGRADABLE_RIGID: 'Biologicky rozložiteľné plasty – pevné',
    BIODEGRADABLE_FLEXIBLE: 'Biologicky rozložiteľné plasty – pružné',
    WOOD_CORK: 'Drevo, korok',
    TEXTILE: 'Textil',
    CERAMICS: 'Keramika alebo porcelánová kamenina',
};

export const PACKAGING_MATERIAL_DESCRIPTIONS = {
    GLASS: 'Fľaše, poháre, flakóny, kozmetické tégliky, dózy, ampulky, liekovky, aerosólové spreje.',
    PAPER_CARDBOARD: 'Škatule, podložky, skupinové obaly, pružné papierové obaly (fólie, listy, vrecká, viečka, kornútky, vrecúška).',
    PAPER_COMPOSITE: 'Obalový kartón na tekutiny (aj laminovaný polyolefínmi/hliníkom), papierové poháre, metalizovaný alebo plastový laminovaný papier.',
    STEEL: 'Plechovky, plechovky na farby, škatule, sudy, tuby (vrátane pocínovaného plechu a nehrdzavejúcej ocele).',
    ALUMINUM_RIGID: 'Potravinové/nápojové plechovky, fľaše, obaly aerosólov, sudy.',
    ALUMINUM_FLEXIBLE: 'Nádoby, tuby, fólie.',
    PET_RIGID: 'Fľaše.',
    PET_FLEXIBLE: 'Fólie.',
    PE_RIGID: 'Nádoby, fľaše, tuby.',
    PE_FLEXIBLE: 'Fólie.',
    PP_RIGID: 'Pevné obaly z PP.',
    PP_FLEXIBLE: 'Pružné obaly z PP.',
    HDPE_PP_RIGID: 'Prepravky, palety.',
    PS_XPS_RIGID: 'Obaly na mliečne výrobky, poháre.',
    EPS_RIGID: 'Škatule na ryby, podložky.',
    OTHER_RIGID_PLASTIC: 'Napr. PVC, PC – kontajnery na voľne ložený náklad, sudy.',
    OTHER_FLEXIBLE_PLASTIC: 'Vrecká, blistery, termoformované/vákuové obaly.',
    BIODEGRADABLE_RIGID: 'Napr. PLA, PHB – pevné obaly.',
    BIODEGRADABLE_FLEXIBLE: 'Napr. PLA, PHB – pružné obaly.',
    WOOD_CORK: 'Palety, škatule, prepravky.',
    TEXTILE: 'Prírodné a syntetické textilné vlákna — tašky.',
    CERAMICS: 'Íl, kameň — tégliky, nádoby, fľaše, dózy.',
};

export const PACKAGING_MATERIAL_OPTIONS = Object.entries(PACKAGING_MATERIAL_LABELS).map(([value, label]) => ({ value, label }));

export const PACKAGING_MATERIAL_GROUPED_OPTIONS = [
    {
        label: 'Sklo',
        options: ['GLASS'],
    },
    {
        label: 'Papier/lepenka',
        options: ['PAPER_CARDBOARD', 'PAPER_COMPOSITE'],
    },
    {
        label: 'Kov',
        options: ['STEEL', 'ALUMINUM_RIGID', 'ALUMINUM_FLEXIBLE'],
    },
    {
        label: 'Plast',
        options: [
            'PET_RIGID', 'PET_FLEXIBLE',
            'PE_RIGID', 'PE_FLEXIBLE',
            'PP_RIGID', 'PP_FLEXIBLE',
            'HDPE_PP_RIGID', 'PS_XPS_RIGID', 'EPS_RIGID',
            'OTHER_RIGID_PLASTIC', 'OTHER_FLEXIBLE_PLASTIC',
            'BIODEGRADABLE_RIGID', 'BIODEGRADABLE_FLEXIBLE',
        ],
    },
    {
        label: 'Drevo, korok',
        options: ['WOOD_CORK'],
    },
    {
        label: 'Textil',
        options: ['TEXTILE'],
    },
    {
        label: 'Keramika alebo porcelánová kamenina',
        options: ['CERAMICS'],
    },
].map(group => ({
    label: group.label,
    options: group.options.map(value => ({ value, label: PACKAGING_MATERIAL_LABELS[value] })),
}));
